import { styled } from "@mui/material"
import React, { ReactElement } from "react"
import { Field } from "react-final-form"
import { LabeledCheckbox } from "../../../../../atoms/LabeledCheckbox"

interface ICheckboxFilterProps {
  name: string,
  label: string,
}

const StyledCheckbox = styled(LabeledCheckbox)({
  marginLeft: "11px"
})

export const CheckboxFilter = (props: ICheckboxFilterProps): ReactElement => {
  return (
    <Field name={props.name}>
      {(field) => (
        <StyledCheckbox
          checked={field.input.value}
          label={props.label}
          onChange={() => field.input.onChange(!field.input.value)}
        />
      )}
    </Field>
  )
}
